import { render, staticRenderFns } from "./StockBatchModDialog.vue?vue&type=template&id=06aa4c72&"
import script from "./StockBatchModDialog.vue?vue&type=script&lang=js&"
export * from "./StockBatchModDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports